import { useState, useEffect } from 'react';
import invoiceService from '../services/invoiceService';

export const useInvoices = () => {
  const [invoices, setInvoices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchInvoices = async () => {
    setLoading(true);
    try {
      const { data, error } = await invoiceService.getAllInvoices();
      if (error) {
        setError(error);
      } else {
        setInvoices(data);
        setError(null);
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const createInvoice = async (invoiceData) => {
    try {
      const { data, error } = await invoiceService.createInvoice(invoiceData);
      if (error) {
        setError(error);
        return { success: false, error };
      }
      
      setInvoices(prev => [data, ...prev]);
      return { success: true, data };
    } catch (err) {
      setError(err.message);
      return { success: false, error: err.message };
    }
  };

  const updateInvoice = async (id, invoiceData) => {
    try {
      const { data, error } = await invoiceService.updateInvoice(id, invoiceData);
      if (error) {
        setError(error);
        return { success: false, error };
      }
      
      setInvoices(prev => prev.map(invoice => invoice.id === id ? data : invoice));
      return { success: true, data };
    } catch (err) {
      setError(err.message);
      return { success: false, error: err.message };
    }
  };

  const deleteInvoice = async (id) => {
    try {
      const { data, error } = await invoiceService.deleteInvoice(id);
      if (error) {
        setError(error);
        return { success: false, error };
      }
      
      setInvoices(prev => prev.filter(invoice => invoice.id !== id));
      return { success: true, data };
    } catch (err) {
      setError(err.message);
      return { success: false, error: err.message };
    }
  };

  const updateInvoiceStatus = async (id, status) => {
    try {
      const { data, error } = await invoiceService.updateInvoiceStatus(id, status);
      if (error) {
        setError(error);
        return { success: false, error };
      }
      
      setInvoices(prev => prev.map(invoice => invoice.id === id ? data : invoice));
      return { success: true, data };
    } catch (err) {
      setError(err.message);
      return { success: false, error: err.message };
    }
  };

  useEffect(() => {
    fetchInvoices();
  }, []);

  return {
    invoices,
    loading,
    error,
    refetch: fetchInvoices,
    createInvoice,
    updateInvoice,
    deleteInvoice,
    updateInvoiceStatus
  };
};

export const useServiceTemplates = () => {
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchTemplates = async () => {
      try {
        const { data } = await invoiceService.getServiceTemplates();
        setTemplates(data);
      } catch (error) {
        console.error('Error fetching service templates:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchTemplates();
  }, []);

  return { templates, loading };
};